import {
  PRODUCT_RECOMMENDATION_STATUS,
  PRODUCT_RECOMMENDATION_STATUS_NUMBER,
} from "vue-app/components/ProductReport/ProductReport.enum";

export const mapProductStatusEnumToProductStatusNumber = (
  status: PRODUCT_RECOMMENDATION_STATUS
): PRODUCT_RECOMMENDATION_STATUS_NUMBER => {
  if (status === PRODUCT_RECOMMENDATION_STATUS.DEFAULT) {
    return PRODUCT_RECOMMENDATION_STATUS_NUMBER.DEFAULT;
  }

  if (status === PRODUCT_RECOMMENDATION_STATUS.EXCLUDED) {
    return PRODUCT_RECOMMENDATION_STATUS_NUMBER.EXCLUDED;
  }

  return PRODUCT_RECOMMENDATION_STATUS_NUMBER.DEFAULT;
};
